export default {
  login: {
    email: 'Adresse email',
    becomeMember: 'Créer un compte et rejoindre la communauté BatiKal',
    submit: 'Rejoignez-nous',
    password: 'Mot de passe',
    verifypassword: 'Verification du mot de passe',
    connect: 'Se connecter',
    forgot: 'Mot de passe oublié ?',
    login_facebook: 'Se connecter avec Facebook',
    login_google: 'Se connecter avec Google',
    login_apple: 'Se connecter avec Apple',
    create_login_facebook: "S'inscrire avec Facebook",
    create_login_google: "S'inscrire avec Google",
    createAccountButton: 'Créer un compte',
    login_manual: 'Créer un compte',
    confirmation: 'Compte crée',
    verification: 'Un email de vérification vous a été envoyé. Veuillez consulter vos messages',
    signup_end: {
      descr_1: 'En créant un compte, vous acceptez de vous conformer à la ',
      descr_pud: 'Politique de confidentialité',
      descr_2: ' et aux ',
      descr_gud: "Conditions générales d'utilisation",
      descr_3: ' de BATIKAL'
    },
    PUD: {
      title: "POLITIQUE D'UTILISATION DES DONNÉES."
    },
    error: {
      not_found: 'Mot de passe ou email incorrect',
      email_invalid: 'Cette adresse email est invalide.',
      email_required: 'Veuillez saisir un email.',
      email_exist: "Cette adresse email n'est pas disponible.",
      password_required: 'Veuillez saisir un mot de passe.',
      password_invalid: 'Le mot de passe doit contenir au minimum 8 caractères dont au moins un chiffre, une minuscule et une majuscule.',
      checkbox_required: 'Veuillez valider les conditions.',
      registerPassword_required: 'Veuillez remplir tous les champs pour vous connecter.',
      registerPassword_mailAlreadyUse: "L'e-mail que vous avez saisie est déjà enregistré",
      registerPassword_mailInvalid: "L'e-mail que vous avez saisie est invalide",
      registerPassword_mailUnknowError: 'Vérifiez que vous avez bien accès à internet. Sinon contactez le support.',
      registerPassword_check: "La vérification du mot de passe n'est pas correcte.",
      toomanyrequest:
        'Nombre de faux mot de passe dépassés. Votre compte est bloqué quelques minutes. Vous pouvez faire un changement de mot de passe pour le réactiver plus rapidement'
    }
  }
}
